import { useState } from 'react';
import { Link } from 'react-router-dom';
import useReveal from '../hooks/useReveal';

const services = [
  {
    title: 'Mutual Fund Advisory – SIP & Lump Sum',
    description:
      'We help you build wealth systematically through SIPs (Systematic Investment Plans) or strategic lump-sum investments. Our advisors guide you through fund selection, risk assessment, and portfolio diversification to maximize returns while minimizing risks. Whether you\'re a first-time investor or looking to optimize existing investments, we provide transparent, conflict-free advice tailored to your financial goals.',
  },
  {
    title: 'Corporate Deposits',
    description:
      'Corporate deposits offer an alternative fixed-income investment option with potentially higher returns than traditional bank deposits. We evaluate creditworthy companies and help you invest in company deposits that align with your risk appetite and investment horizon. Our team conducts thorough due diligence to ensure safety and reliability of your investments.',
  },
  {
    title: 'Portfolio Management Services (PMS)',
    description:
      'Our Portfolio Management Services offer personalized investment strategies for high-net-worth individuals. With professional fund managers actively managing your portfolio, we ensure optimal asset allocation, timely rebalancing, and strategic investments across equity, debt, and alternative assets. Experience customized wealth management that adapts to market conditions and your evolving financial needs.',
  },
  {
    title: 'Insurance Planning',
    description:
      "Protect your family's future with comprehensive insurance planning. We assess your life stage, financial obligations, and family needs to recommend appropriate life, health, and term insurance policies. Our goal is to ensure adequate coverage without over-insurance, providing financial security at optimal premium costs. Plan before life events demand it.",
  },
  {
    title: 'Retirement Planning (NPS & Bonds)',
    description:
      'Secure your golden years with strategic retirement planning. We help you leverage National Pension System (NPS) benefits, invest in government and corporate bonds, and create a retirement corpus that ensures financial independence by age 45-60. Our retirement strategies focus on tax efficiency, regular income generation, and wealth preservation for a comfortable post-retirement life.',
  },
  {
    title: 'Loan Against Mutual Funds',
    description:
      "Access liquidity without liquidating your investments. Loan against mutual funds allows you to meet urgent financial needs while keeping your investments intact and growing. We facilitate this service with competitive interest rates and minimal documentation, ensuring you don't disturb your long-term wealth creation journey for short-term requirements.",
  },
  {
    title: 'Postal Savings Services',
    description:
      'Traditional yet reliable, postal savings schemes offer government-backed security with reasonable returns. We guide you through various options like PPF (Public Provident Fund), NSC (National Savings Certificate), and post office recurring deposits. These instruments are ideal for conservative investors seeking capital protection with tax benefits and guaranteed returns.',
  },
  {
    title: 'Portfolio Review & Rebalancing',
    description:
      'Our regular portfolio review service identifies underperforming assets, assesses changing risk profiles, and recommends strategic rebalancing. We ensure your investments remain aligned with your goals, market conditions, and life stage changes. Annual reviews help optimize returns while managing risk effectively.',
  },
];

const Services = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  useReveal();

  const handleToggle = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  return (
    <>
      <section className="page-hero">
        <h1>Services</h1>
      </section>

      <section className="what-we-do">
        <div className="intro-container always-visible">
          <div className="section-label">Services</div>
          <h2>What We Do</h2>
          <p>
            MyFundz offers a trusted range of financial solutions including mutual fund advisory,
            retirement planning, insurance and portfolio management to support your long
            term financial security.
          </p>
        </div>
      </section>

      <section className="services-section">
        <div className="services-grid">
          {services.map((service, index) => (
            <div
              className={`service-item ${activeIndex === index ? 'active' : ''}`}
              key={service.title}
            >
              <button
                type="button"
                className="service-header"
                onClick={() => handleToggle(index)}
              >
                <h3>{service.title}</h3>
                <div className="service-icon">▼</div>
              </button>
              <div className="service-content">
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="need-help">
        <div className="help-container">
          <div className="help-visual">
            <div className="decorative-blocks">
              {/* <div className="block"></div>
              <div className="block"></div>
              <div className="block"></div>
              <div className="block"></div>
              <div className="block"></div>
              <div className="block"></div> */}

            <img src="/images/services/1.png" alt="Our Vision & Mission" style={{ width: "100%", height: "auto", borderRadius: "24px", boxShadow: "0 20px 40px rgba(0,0,0,0.1)" }} />



            </div>
          </div>
          <div className="help-content fade-in">
            <h2>"Need Help?"</h2>
            <h3>Not Sure Which Investment Option Suits You?</h3>
            <p>Wrong Choices Cost More Than Delayed Investing.</p>
            <p>A Quick Consultation Brings Clarity.</p>
            <p>Plan Before You Invest</p>
            <Link to="/contact" className="cta-button">Get a Free Financial Assessment</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
